$(function(){
  //要素取得
  const naviBtn = $('.js-naviBtn');
  const hasDropDown = $('.js-hasDropdown');
  const Anchor = $('.js-naviAnchor');

  let $win = $(window);
  let ww = window.innerWidth;
  let currentWidth = window.innerWidth;
  let breakpoint = 834;

  //メニューボタンを押した方のメニューが開閉
  naviBtn.on('click',function() {
    let currentCat = $(this).data('cat');
    if (
      $(this).hasClass('is-Active')
    ) {
      $(this).removeClass('is-Active');
      $('.l-navigation__wrapper').fadeOut();
      $('html').removeClass('open');
    } else {
      $(naviBtn).removeClass('is-Active');
      $(this).addClass('is-Active');
      $('.l-navigation__wrapper').fadeOut();
      $('#' + currentCat).fadeIn();
      $('html').addClass('open');
    }
  });

  //横幅変更を監視
  $(window).resize(function(){
    ww = window.innerWidth;
    if( ww <= breakpoint ) {
      $('.l-navigation__list-sub').hide();
    } else {
      $('.l-navigation__list-sub').show();
    }
  });

  //アンカーリンクをクリックした際にgnaviが閉じる
  Anchor.on('click',function() {
    naviBtn.removeClass('is-Active');
    $('.l-navigation__wrapper').delay(200).fadeOut();
    $('html').removeClass('open');
  });


  //タブレット以下でサブメニューをアコーディオンに変更
  hasDropDown.on('click',function() {
    if (
      $(this).parent().hasClass('is-dropdown')
    ) {
      $(this).parent().removeClass('is-dropdown');
      $(this).siblings('[class="l-navigation__list-sub"]').slideUp();
    } else {
      $(this).parent().addClass('is-dropdown');
      $(this).siblings('[class="l-navigation__list-sub"]').slideDown();
    }
  });
})
